import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@iclinic/design-system';

import {
  composeTextFormPayment,
  composeTitleNotification,
  normalizeTransactionOrigin,
} from 'features/onlinePayment/utils';
import { ApprovedPaymentNotification } from 'features/onlinePayment/state/notifications-center/types';
import { getUnreadNotifications } from 'features/onlinePayment/state/notifications-center/selectors';
import NotificationIcon from '../NotificationIcon';
import * as S from '../styles';
import { currencyFormatter } from 'shared/utils/formatters';

type PaymentApprovedProps = {
  notification: ApprovedPaymentNotification;
};

const PaymentApproved = ({
  notification,
}: PaymentApprovedProps): JSX.Element => {
  const unreadNotifications = useSelector(getUnreadNotifications);
  const {
    id,
    read,
    messageType,
    createdAt,
    data: { patient_name, type, installments, origin, amount },
  } = notification;

  return (
    <S.NotificationWrapper
      display="flex"
      justifyContent="space-between"
      pb={2}
      key={id}
      read={read || !unreadNotifications}
    >
      <Box display="flex">
        <S.IconWrapper>
          <NotificationIcon notificationType={messageType} />
        </S.IconWrapper>
        <Box ml={1}>
          <S.Title variant="xxs" bold>
            {composeTitleNotification(messageType)}
          </S.Title>
          <S.Text variant="xxs">{createdAt}</S.Text>
          <S.Text variant="xxs">{patient_name}</S.Text>
          <S.Text variant="xxs">
            {composeTextFormPayment(type, installments)}
          </S.Text>
          <S.Text variant="xxs">{normalizeTransactionOrigin(origin)}</S.Text>
        </Box>
      </Box>
      <Box>
        <S.Price variant="xxs" bold>
          {currencyFormatter(amount)}
        </S.Price>
      </Box>
    </S.NotificationWrapper>
  );
};

export default PaymentApproved;
